import { GetterTree } from 'vuex'
import { MenuState } from '@/modules/cms/modules/menu/store'
import { RootState } from '@/store/types'
import MenuEntry from '@/modules/cms/modules/menu/model/MenuEntry';
import MenuEntryTranslation from '../model/MenuEntryTranslation';

/**
 * Busca de forma recursiva en la entrada argumentada un elemento cuyo id
 * temporal tenga el mismo id que el argumentado
 *
 * @param entry {MenuEntry}
 * @param id {string}
 */
export function searchItemRecursive (entry: MenuEntry, id: string): MenuEntry | null {
    if (entry.tempId === id) {
        return entry
    }

    for (const item of entry.items) {
        const result = searchItemRecursive(item, id)
        if (result) {
            return result
        }
    }

    return null
}

const getters: GetterTree<MenuState, RootState> = {
    /**
     * Obtiene un item del menu actualmente seleccionado, busca de forma recurviva
     */
    itemOfCurrentMenu: (state) => (id: string) => searchItemRecursive(state.currentMenu, id),

    currentTranslation: (state) => {
        // No se utiliza el método MenuEntry.translate para evitar modificar la entidad
        // durante una operación de lectura
        return state.currentMenuItem.translations.find(t => t.locale === state.currentLocale)
        || new MenuEntryTranslation(state.currentLocale)
    },
}

export default getters
